import React, { useState, FC, useEffect, useContext, useMemo } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import {
    ITERRequest,
    defTERAmmendAppStatus,
    defTERAppStatus,
    defTERExchangeAppStatus,
    defTERAmmendRowAppStatus,
} from "../../typings/interfaces/Requests/TERRequest";
import { ILabFeeLineItemInput } from "../../typings/interfaces/Requests/LabFeeLineItemInput";
import { ICalculateFeeResponseModel } from "../../typings/interfaces/Requests/CalculateFeeResponseModel";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
    saveTERApplications,
    SaveTERDraftApplications,
    saveTERAmendApplications,
    labCalculateFee,
    getLabMaster,
} from "../../api/apimethods";
import { TERMetaContext } from "../../App";
import { notify } from "../../utils";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import { helper } from "../../utils/helper";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import PersonalInformation from "./Helper/ProfileInformation";
import { TypeOfApplicationEnum } from "../../utils/enum";
import { defaultAppContextData } from "../../services/appData";
import { useContextService } from "../../services";
import { ILabTerFeeInput } from "../../typings/interfaces/Requests/LabTerFeeInput";
import { ITERSamplesAndTests } from "../../typings/models/TERSamplesAndTests";
import Loader from "../../components/molecules/Loader";
import { defAmendmentRaisedStage } from "../../typings/interfaces/Requests/AquaRequest";
export interface PersonalInfo {
    customerName: string;
    mobileNumber: string;
    email: string;
    address: string;
    homeNumber: string;
    customerNRIC: string;
    modeOfPayment: string;
    typeOfService: string;
    typeOfApplication: number;
    projectName: string;
    specialInstruction: string;
    otherRemarks: string;
}
interface UenEntry {
    uen: string;
    contractAmount: string;
    lowBalanceAmount: string;
}
const { message } = notify();
const { btnLoaderHandler } = helper();

const stepWizardConfig: IStepwizardProps = {
    currentStep: 4,
    steps: [
        {
            name: "Choose Application",
        },

        {
            name: "Samples & Tests",
        },
        {
            name: "Review",
        },
        {
            name: "Cost & Confirm",
        },
        {
            name: "Acknowledgement",
        },
    ],
};

function CAVSFRWCostAndConfirm() {
    const navigate = useNavigate();
    const { getContextValueFromStorage } = useContextService();
    const [contextData] = useState(() =>
        getContextValueFromStorage(defaultAppContextData)
    );
    const user = contextData.user;
    const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
    const [btnNameForDraft, setBtnNameForDraft] = useState<string>("");
    const [labTerFees, setTerLabFees] =
        useState<ICalculateFeeResponseModel | null>(null);
    const { TERMeta } = useContext(TERMetaContext);
    const [acknowledgmentNumber, setAcknowledgmentNumber] = useState<string>("");
    const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
        string | null
    >(null);
    const [feesAfterGST, setFeesAfterGST] = useState<number>(0);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState("");
    const actionedStatus = localStorage.getItem("psh-app-status");
    const stripHtmlTags = (str: string) => {
        return str.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, "");
    };
    const [isButtonVisible, setIsButtonVisible] = useState(true);
    const [modeOfPayment, setModeOfPayment] = useState<string>(
        localStorage.getItem("modeOfPayment") || "Credit Card"
    );
    const [pageLoader, setPageLoader] = useState<boolean>(false);
    const [uenValues, setUenValues] = useState<UenEntry[]>([]);
    const [contractAmount, setContractAmount] = useState<number | null>(null);
    const [lowBalanceAmount, setLowBalanceAmount] = useState<number | null>(null);
    const [ModeOfPaymentErrMsg, setModeOfPaymentErrMsg] = useState("");
    let requestMeta: ITERRequest = TERMeta.TERMeta;
    const getUserInfo = localStorage.getItem("app-data");
    const userInfo = JSON.parse(getUserInfo || "");
    let NRIC = userInfo?.user?.idNo || null;
    let UEN = userInfo?.user?.uen || null;
    let role = userInfo?.user?.role || "";
    const customerIdentifier = role === "CorpPass" ? UEN : NRIC;
    const handlePreviousClick = () => {
        navigate("/frw-review");
    };
    useEffect(() => {
        fetchAndSetMasterData();
    }, []);
    const fetchAndSetMasterData = async () => {
        setPageLoader(true);

        try {
            const labMasterResponse = await getLabMaster();
            if (labMasterResponse?.status === 200) {
                const masters = labMasterResponse.data.masters;

                if (masters?.exchangeOfServices) {
                    setUenValues(masters.exchangeOfServices);
                } else {
                    console.warn("No exchangeOfServices found in the master data.");
                }
            } else {
                console.error(
                    `Failed to fetch lab master data: ${labMasterResponse?.status}`
                );
            }
        } catch (error) {
            console.error("Error while fetching lab master data:", error);
        } finally {
            setPageLoader(false);
        }
    };
    const memoizedUenValues = useMemo(() => uenValues, [uenValues]);

    useEffect(() => {
        const matchedData = memoizedUenValues.find(
            (entry: UenEntry) => entry.uen === customerIdentifier
        );

        if (matchedData) {
            const amount = parseFloat(matchedData.contractAmount);
            const lowamount = parseFloat(matchedData.lowBalanceAmount);
            if (contractAmount !== amount) {
                setContractAmount(amount);
                setLowBalanceAmount(lowamount);
            }
        } else {
            if (contractAmount !== null) {
                setContractAmount(null);
                setLowBalanceAmount(null);
            }
        }
    }, [memoizedUenValues, contractAmount, lowBalanceAmount]);

    useEffect(() => {
        if (modeOfPayment) {
            setErrorMessage("");
            const timeoutId = setTimeout(() => {
                fetchLabCalculateFee();
            }, 1000);

            return () => clearTimeout(timeoutId);
        }
    }, [modeOfPayment]);

    const fetchLabCalculateFee = async () => {
        try {
            let requestMeta: ITERRequest = TERMeta.TERMeta;
            let applicationTypeText = "New";
            if (requestMeta.actionStatus === TypeOfApplicationEnum.amendment) {
                applicationTypeText = TypeOfApplicationEnum.amendment;
            }

            let sampleDataMeta: ITERSamplesAndTests[] = [];

            if (Object.keys(requestMeta)?.length) {
                sampleDataMeta = requestMeta?.labTERSampleTests;
            }

            let feeLineItems: ILabFeeLineItemInput[] = [];
            if (sampleDataMeta.length) {
                sampleDataMeta.forEach(function (v) {
                    const sampleRowId: number =
                        typeof v?.sampleRowId === "number" ? v?.sampleRowId : 0;
                    v?.labTERTestDetails?.forEach((element) => {
                        const testRowId = element?.rowId || 0;
                        let ILabFeeLineItemInput: ILabFeeLineItemInput = {
                            testCode: stripHtmlTags(element?.testDescription || ""),
                            testName: stripHtmlTags(element?.testDescription || ""),
                            packageCode: "",
                            packageName: "",
                            sampleName: v?.sampleMarking || "",
                            sampleDescription: v?.sampleMarking || "",
                            testCount: element?.nooftestsrequired ?? 1,
                            testrowId: testRowId,
                            sampleRowId: sampleRowId,
                        };
                        feeLineItems.push(ILabFeeLineItemInput);
                    });
                });
            }
            let labApplicationchangedDetails = null;
            let labChangedPreference = null;
            let labchangedSampleTestDetails = null;

            if (
                actionedStatus === "Report Released" ||
                actionedStatus === "Application Closed" ||
                actionedStatus === "Report Hard Copy Collected"
            ) {
                labApplicationchangedDetails =
                    requestMeta.labApplicationchangedDetails || null;
                labChangedPreference = requestMeta.labChangedPreference || null;
                labchangedSampleTestDetails =
                    requestMeta.labchangedSampleTestDetails?.map(
                        ({ labTERTestDetails, ...rest }) => ({
                            ...rest,
                            labTERTestDetails: [],
                        })
                    ) || null;
            }

            let labFeeInput: ILabTerFeeInput = {
                transactionType: 1,
                purposeCode: "FRW",
                typeofService: "CAVS Laboratory Services",
                applicationNumber: requestMeta?.applicationNumber || "",
                applicationType: applicationTypeText,
                feeLineItems: feeLineItems,
                labApplicationchangedDetails,
                labChangedPreference,
                labchangedSampleTestDetails,
            };

            const response = await labCalculateFee(labFeeInput);
            setTerLabFees(response.data);
            setFeesAfterGST(response.data?.feesAfterGST || 0);

            if (
                modeOfPayment === "Exchange of Service agreement" &&
                contractAmount !== null &&
                response.data?.feesAfterGST &&
                response.data?.feesAfterGST >= contractAmount
            ) {
                setIsButtonVisible(false);
                message(
                    NotifyType.Error,
                    "The fees exceed the contract amount. Please review the charges."
                );
                setModeOfPaymentErrMsg(
                    `${ErrMsg.ExchangeofServiceErrMsg} ${labTerFees?.feesAfterGST}`
                );
            } else {
                setIsButtonVisible(true);
                setModeOfPaymentErrMsg("");
            }
        } catch (error) {
            console.error("Error fetching test code master data:", error);
            message(
                NotifyType.Error,
                "An error occurred while calculating the fees. Please try again."
            );
        }
    };
    const formatDescription = (description: string | null) => {
        if (!description) return "";
        return description
            .replace(/<i>/g, "<em>")
            .replace(/<\/i>/g, "</em>")
            .replace(/<li>/g, "<i>")
            .replace(/<\/li>/g, "</i>");
    };
    const location = useLocation();
    const state = location.state as {
        personalInfo: PersonalInfo;
        selectedType: string;
    };

    const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
        setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
    };
    const handleDraftLoader = (
        enableLoader: boolean,
        btnNameForDraft: string
    ) => {
        setBtnNameForDraft(enableLoader ? btnNameForDraft : "");
    };
    const handleSaveDraftClick = async () => {
        try {
            handleDraftLoader(true, "submit-request");

            const profileInfo = localStorage.getItem("profile-info");
            const personalInfoDetails = profileInfo ? JSON.parse(profileInfo) : {};
            const meta: ITERRequest = {
                ...TERMeta.TERMeta,
                labTERPersonalInfoDetails: personalInfoDetails,
            };
            if (meta.labTERSampleTests) {
                meta.labTERSampleTests.forEach((sample: any) => {
                    if (sample.labTERTestDetails) {
                        sample.labTERTestDetails.forEach((test: any) => {
                            test.testDescription = stripHtmlTags(test.testDescription);
                        });
                    }
                });
            }

            const response1 = await SaveTERDraftApplications(meta);

            if (response1.status === 200) {
                const acknowledgmentNumberMatch = response1.data.match(
                    /CAVS_TERApplicationNumber:\s*([A-Z0-9]+)/
                );

                const acknowledgmentNumber = acknowledgmentNumberMatch
                    ? acknowledgmentNumberMatch[1]
                    : undefined;
                if (acknowledgmentNumber) {
                    meta.applicationNumber = acknowledgmentNumber;
                    if (meta.actionStatus === TypeOfApplicationEnum.submit) {
                        meta.actionStatus = "Draft";
                    }
                    TERMeta.updateTERMeta(meta);
                }
                message(
                    NotifyType.Success,
                    acknowledgmentNumber
                        ? `Draft Saved Successfully`
                        : "Draft Saved Successfully"
                );

                setAcknowledgmentMessage(
                    acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
                );
                localStorage.removeItem("psh-app-applicationNum");
                localStorage.removeItem("ismetadata");
                localStorage.removeItem("psh-app-status");
            } else {
                message(NotifyType.Error, "Issue on the request submission.");
                handleDraftLoader(false, "submit-request");
            }
        } catch (error) {
            console.error(ErrMsg.InternalServerErrMsg, error);
            message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
        } finally {
            handleDraftLoader(false, "");
        }
    };

    const handleSubmit = async () => {
        try {
            if (!isCheckboxChecked) {
                message(NotifyType.Error, "Please check the Acknowledgement checkbox.");
                return;
            }
            handleLoader(true, "submit-req");

            const profileInfo = localStorage.getItem("profile-info");
            const modeOfPayment = localStorage.getItem("modeOfPayment");
            const personalInfoDetails = profileInfo ? JSON.parse(profileInfo) : {};
            let requestMeta: ITERRequest = {
                ...TERMeta.TERMeta,
                labTERPersonalInfoDetails: personalInfoDetails,
            };
            const purposeOfTest =
                requestMeta?.labTERApplicationDetails?.purposeOfTest;

            if (purposeOfTest === 1 && modeOfPayment !== "Biosurveillance") {
                setErrorMessage(ErrMsg.BiosurveillancepaymentmodeErrMsg);
                message(NotifyType.Error, "Please check the error message.");
                handleLoader(false, "submit-req");
                return;
            }

            if (modeOfPayment === "Biosurveillance" && purposeOfTest !== 1) {
                setErrorMessage(ErrMsg.BiosurveillancePurposeofTestErrMsg);
                message(NotifyType.Error, "Please check the error message.");
                handleLoader(false, "submit-req");
                return;
            }

            setErrorMessage("");

            if (
                modeOfPayment === "Exchange of Service agreement" &&
                contractAmount !== null &&
                labTerFees?.feesAfterGST &&
                labTerFees?.feesAfterGST >= contractAmount
            ) {
                setIsButtonVisible(false);
                message(
                    NotifyType.Error,
                    "The fees exceed the contract amount. Please review the charges."
                );

                setModeOfPaymentErrMsg(
                    `${ErrMsg.ExchangeofServiceErrMsg} ${labTerFees?.feesAfterGST}`
                );
                handleLoader(false, "submit-req");
                return;
            } else {
                setIsButtonVisible(true);
                setModeOfPaymentErrMsg("");
            }
            if (Object.keys(requestMeta).length > 0) {
                const actionedStatus = localStorage.getItem("psh-app-status");
                const isExchangeOfService =
                    requestMeta.labTERPersonalInfoDetails.modeOfPayment ===
                    "Exchange of Service agreement" ||
                    requestMeta.labTERPersonalInfoDetails.modeOfPayment ===
                    "Biosurveillance";
                let response1;
                let amendmentRaisedStage: number | null = null;

                if (actionedStatus && actionedStatus in defAmendmentRaisedStage) {
                    amendmentRaisedStage =
                        defAmendmentRaisedStage[
                        actionedStatus as keyof typeof defAmendmentRaisedStage
                        ];
                }

                if (requestMeta.labTERSampleTests) {
                    requestMeta.labTERSampleTests.forEach((sample: any) => {
                        if (sample.labTERTestDetails) {
                            sample.labTERTestDetails.forEach((test: any) => {
                                test.testDescription = stripHtmlTags(test.testDescription);
                            });
                        }
                    });
                }

                if (requestMeta.actionStatus === TypeOfApplicationEnum.draft) {
                    requestMeta.applicationNumber = requestMeta.applicationNumber || "";
                }

                if (requestMeta.actionStatus === TypeOfApplicationEnum.submit) {
                    delete requestMeta.applicationNumber;
                }

                if (requestMeta.actionStatus === TypeOfApplicationEnum.amendment) {
                    let labTERApplicationStatus;

                    const hasRowIdMismatch = requestMeta.labTERSampleTests.some(
                        (sample) =>
                            Number(sample?.rowId ?? 0) > Number(sample?.sampleCaseRowId ?? 0)
                    );

                    if (
                        (actionedStatus === "Testing In Progress" ||
                            actionedStatus === "Sample(s) Received") &&
                        hasRowIdMismatch
                    ) {
                        labTERApplicationStatus = defTERAmmendRowAppStatus;
                    } else {
                        labTERApplicationStatus = defTERAmmendAppStatus;
                    }
                    requestMeta.labTERApplicationStatus = {
                        ...labTERApplicationStatus,
                        amendmentRaisedStage: amendmentRaisedStage,
                        actionedStatus: actionedStatus || "",
                    };
                    requestMeta.applicationNumber = requestMeta.applicationNumber || "";
                    response1 = await saveTERAmendApplications(requestMeta);
                } else {
                    requestMeta.labTERApplicationStatus = isExchangeOfService
                        ? defTERExchangeAppStatus
                        : defTERAppStatus;

                    response1 = await saveTERApplications(requestMeta);
                }
                if (response1.status === 200) {
                    const {
                        TERApplicationNumber,
                        ApplicationDate,
                        ApplicantName,
                        ApplicantEmail,
                        Species,
                    } = JSON.parse(response1.data as any);
                    const acknowledgmentNumber = TERApplicationNumber;
                    const applicationDate = ApplicationDate;
                    const species = Species;
                    const applicantName = ApplicantName;
                    const applicantEmail = ApplicantEmail;
                    const balanceAmount =
                        contractAmount !== null ? contractAmount - feesAfterGST : 0;
                    const lowBalancedAmount = lowBalanceAmount;

                    message(NotifyType.Success, "Request Submitted Successfully");
                    TERMeta.updateTERMeta({});

                    localStorage.removeItem("psh-app-applicationNum");
                    localStorage.removeItem("psh-app-status");

                    localStorage.removeItem("profile-info");
                    setTimeout(() => {
                        handleLoader(false, "submit-req");
                        navigate("/frw-acknowledgement", {
                            state: {
                                acknowledgmentNumber,
                                applicationDate,
                                applicantName,
                                applicantEmail,
                                balanceAmount:
                                    modeOfPayment === "Exchange of Service agreement"
                                        ? balanceAmount
                                        : null,
                                lowBalancedAmount:
                                    modeOfPayment === "Exchange of Service agreement"
                                        ? lowBalancedAmount
                                        : null,
                            },
                        });
                    }, 5000);
                } else {
                    message(NotifyType.Error, "Issue on the request submission.");
                    handleLoader(false, "submit-req");
                }
            }
        } catch (error: any) {
            console.error(ErrMsg.InternalServerErrMsg, error);
            message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
            handleLoader(false, "submit-req");
        }
    };

    useEffect(() => {
        btnLoaderHandler(btnNameForLoader ? true : false);
    }, [btnNameForLoader]);

    return (
        <>
            <Header />
            <Container>
                <div className="h1Lab"> Application for Laboratory Testing </div>
                <Stepwizard
                    currentStep={stepWizardConfig.currentStep}
                    steps={stepWizardConfig.steps}
                />
                <div className="row setup-content" id="step-4">
                    {pageLoader ? (
                        <Loader />
                    ) : (
                        <div className="col-md-12">
                            <div className="tab-wizard-content">
                                {acknowledgmentMessage && (
                                    <div className="info-content">
                                        <div className="att">
                                            <h3>Attention</h3>
                                            <br />
                                            <p className="attention">
                                                {">"} Application has been successfully Saved as Draft.
                                                Service Acknowledgement Number: &nbsp;
                                                {acknowledgmentNumber ? acknowledgmentNumber : ""}
                                            </p>
                                            {acknowledgmentMessage}
                                        </div>
                                    </div>
                                )}
                                {errorMessage && (
                                    <div className="info-content">
                                        <div className="att">
                                            <br />
                                            <div className="text-danger">
                                                <center>{errorMessage}</center>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {ModeOfPaymentErrMsg && (
                                    <div className="info-content">
                                        <div className="att">
                                            <br />
                                            <div className="text-danger">
                                                <center>{ModeOfPaymentErrMsg}</center>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <PersonalInformation onModeOfPaymentChange={setModeOfPayment} />
                            </div>
                        </div>
                    )}
                </div>
                <div className="personal-info">
                    <div className="info-heading">
                        <p className="float-end pro-cnt">
                            <span className="star-red">*</span>This is an Estimated cost.
                            Total amount payable to be confirmed upon sample submission.
                        </p>
                        <h2>Estimation Of Cost</h2>
                    </div>

                    <div className="info-content ">
                        <div className="table-responsive last-bg mt-2 mb-2">
                            <table className="table table-striped product_table start_table table-02">
                                <thead>
                                    <tr>
                                        <th>S/N</th>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Quantity</th>
                                        {user?.role !== "ForeignerLogin" && (
                                            <th>Unit Price (S$)</th>
                                        )}
                                        {user?.role !== "ForeignerLogin" && (
                                            <th>GST Amount (S$)</th>
                                        )}
                                        <th>Amount (S$)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {labTerFees?.originalfeeLineItemsResponse &&
                    labTerFees.originalfeeLineItemsResponse.length > 0 && (
                      <>
                        {labTerFees?.applicationType ===
                          TypeOfApplicationEnum.amendment && (
                          <tr>
                            <td className="fnt-wgg" colSpan={7}>
                              Original
                            </td>
                          </tr>
                        )}
                        {labTerFees?.originalfeeLineItemsResponse?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item.sNo}</td>
                              <td
                                dangerouslySetInnerHTML={{
                                  __html: formatDescription(
                                    item.description2
                                      ? item.description2
                                      : item.name
                                  ),
                                }}
                              ></td>
                              <td>{item.description}</td>
                              <td>{item.quantity}</td>
                              {user?.role !== "ForeignerLogin" && (
                                <td>{item.unitAmt?.toFixed(2)}</td>
                              )}
                              {user?.role !== "ForeignerLogin" && (
                                <td>{item.gstAmt?.toFixed(2)}</td>
                              )}
                              <td>{item.netAmt?.toFixed(2)}</td>
                            </tr>
                          )
                        )}
                      </>
                    )} */}
                                    {/* {labTerFees?.deletedfeeLineItemsResponse &&
                    labTerFees.deletedfeeLineItemsResponse.length > 0 && (
                      <>
                        {labTerFees?.applicationType ===
                          TypeOfApplicationEnum.amendment && (
                          <tr>
                            <td className="fnt-wgg" colSpan={7}>
                              Removed
                            </td>
                          </tr>
                        )}
                        {labTerFees?.deletedfeeLineItemsResponse?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item.sNo}</td>
                              <td
                                dangerouslySetInnerHTML={{
                                  __html: formatDescription(
                                    item.description2
                                      ? item.description2
                                      : item.name
                                  ),
                                }}
                              ></td>
                              <td>{item.description}</td>
                              <td>{item.quantity}</td>
                              {user?.role !== "ForeignerLogin" && (
                                <td>{item.unitAmt?.toFixed(2)}</td>
                              )}
                              {user?.role !== "ForeignerLogin" && (
                                <td>{item.gstAmt?.toFixed(2)}</td>
                              )}
                              <td>{item.netAmt?.toFixed(2)}</td>
                            </tr>
                          )
                        )}
                      </>
                    )} */}

                                    {labTerFees?.feeLineItemsResponse &&
                                        labTerFees.feeLineItemsResponse.length > 0 && (
                                            <>
                                                {labTerFees?.applicationType ===
                                                    TypeOfApplicationEnum.amendment && labTerFees?.feesBeforeGST > 0 && (
                                                        <tr>
                                                            <td className="fnt-wgg" colSpan={7}>
                                                                Outstanding Payment
                                                            </td>
                                                        </tr>
                                                    )}

                                                {labTerFees?.feeLineItemsResponse?.map(
                                                    (item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.sNo}</td>
                                                            <td
                                                                dangerouslySetInnerHTML={{
                                                                    __html: formatDescription(
                                                                        item.description2
                                                                            ? item.description2
                                                                            : item.name
                                                                    ),
                                                                }}
                                                            ></td>
                                                            <td>{item.description}</td>
                                                            <td>{item.quantity}</td>
                                                            {user?.role !== "ForeignerLogin" && (
                                                                <td>{item.unitAmt?.toFixed(2)}</td>
                                                            )}
                                                            {user?.role !== "ForeignerLogin" && (
                                                                <td>{item.gstAmt?.toFixed(2)}</td>
                                                            )}
                                                            <td>{item.netAmt?.toFixed(2)}</td>
                                                        </tr>
                                                    )
                                                )}
                                            </>
                                        )}

                                    {user?.role !== "ForeignerLogin" && (
                                        <tr>
                                            <td className="fnt-wg total-fees-payable" colSpan={6}>
                                                Total Fees Payable (Before GST)
                                            </td>
                                            <td className="total-fees-payable">
                                                {labTerFees?.feesBeforeGST?.toFixed(2)}
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td
                                            className="fnt-wg"
                                            colSpan={user?.role === "ForeignerLogin" ? 4 : 6}
                                        >
                                            {user?.role !== "ForeignerLogin"
                                                ? "Total GST Payable"
                                                : "Total Fees Payable"}
                                        </td>
                                        <td>
                                            {user?.role !== "ForeignerLogin"
                                                ? labTerFees?.totalGST?.toFixed(2)
                                                : labTerFees?.feesAfterGST?.toFixed(2)}
                                        </td>
                                    </tr>
                                    {user?.role !== "ForeignerLogin" && (
                                        <tr>
                                            <td className="fnt-wg" colSpan={6}>
                                                Total Fees Payable (After GST)
                                            </td>
                                            <td>{labTerFees?.feesAfterGST?.toFixed(2)}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <p>Acknowledgement</p>
                        <div className="form-check">
                            <input
                                className="form-check-input mt-2"
                                type="checkbox"
                                checked={isCheckboxChecked}
                                id="flexCheckDefault"
                                onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
                            />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Please check that your laboratory services application is in
                                order before you submit it. There will be no refund once payment
                                is made.
                            </label>
                        </div>
                    </div>
                </div>
                <div className="text-end mt-3 mb-3">
                    {requestMeta.actionStatus !== TypeOfApplicationEnum.amendment && (
                        <button
                            className="btn btn-d btn-secondry  px-4"
                            onClick={handleSaveDraftClick}
                            disabled={btnNameForDraft === "submit-request"}
                        >
                            {btnNameForDraft === "submit-request"
                                ? "Submitting..."
                                : "Save Draft"}
                        </button>
                    )}
                    <button
                        className="btn btn-d btn-secondary px-4"
                        onClick={handlePreviousClick}
                    >
                        Previous
                    </button>
                    {isButtonVisible && (
                        <button
                            className="btn btn-d btn-primary"
                            type="button"
                            name="submit-req"
                            onClick={handleSubmit}
                        >
                            Submit
                            {btnNameForLoader == "submit-req" ? (
                                <Spinner
                                    className="btn-spinner"
                                    animation="border"
                                    variant="light"
                                />
                            ) : (
                                ""
                            )}
                        </button>
                    )}
                </div>
            </Container>
            <Footer />
        </>
    );
}
export default CAVSFRWCostAndConfirm;
